import { useState } from "react"
import { router } from "@inertiajs/react"
import { Shield } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { PhoneInput, parsePhone, formatFullPhone } from "@/components/ui/phone-input"

interface Props {
  phone?: string
  error?: string
}

export default function Login({ phone: initialPhone, error }: Props) {
  const parsed = parsePhone(initialPhone || "")
  const [processing, setProcessing] = useState(false)
  const [countryCode, setCountryCode] = useState(parsed.countryCode)
  const [localPhone, setLocalPhone] = useState(parsed.localPhone)

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setProcessing(true)
    router.post("/admin/login/request_otp", {
      phone: formatFullPhone(countryCode, localPhone),
    }, {
      onFinish: () => setProcessing(false),
    })
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Shield className="h-6 w-6" />
          </div>
          <CardTitle className="text-xl">Tippy Admin</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="phone">Teléfono</Label>
              <PhoneInput
                countryCode={countryCode}
                localPhone={localPhone}
                onCountryCodeChange={setCountryCode}
                onLocalPhoneChange={setLocalPhone}
              />
            </div>

            {error && <p className="text-sm text-destructive">{error}</p>}

            <Button type="submit" className="w-full" disabled={processing}>
              {processing ? "Enviando..." : "Enviar código"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
